<script setup lang="ts">
import {ExternalLink, Home, Layers, Quote, ShieldCheck, Star} from "lucide-vue-next";
import "@/assets/styles/reference.css";

const references = [
  {
    icon: Home,
    title: "Steildach-Sanierung Wohnhaus",
    category: "Dachsanierung",
    image: "/images/references/steildach.png",
    text: "Neue Eindeckung mit langlebigem Systemaufbau, sauberer Entwässerung und präzisen Anschlüssen."
  },
  {
    icon: ShieldCheck,
    title: "Sturmschaden schnell gesichert",
    category: "Notdienst",
    image: "/images/references/sturmschaden.png",
    text: "Kurzfristige Sicherung, Schadensaufnahme und fachgerechte Reparatur nach starkem Unwetter."
  },
  {
    icon: Layers,
    title: "Flachdach-Abdichtung Gewerbe",
    category: "Flachdach",
    image: "/images/references/flachdach.png",
    text: "Robuste Abdichtung mit klarer Detailausbildung für dauerhaft trockene Nutzflächen."
  }
];

const reviews = [
  {
    name: "Familie Schneider",
    text: "Alles lief reibungslos. Sehr saubere Arbeit und ein Dach, das wieder richtig hochwertig aussieht."
  },
  {
    name: "Michael Bauer",
    text: "Pünktlich, zuverlässig und fachlich sehr stark umgesetzt."
  },
  {
    name: "Sandra Keller",
    text: "Nach dem Schaden wurde schnell reagiert und sauber repariert. Absolute Empfehlung!"
  }
];
</script>

<template>

  <section class="references">

    <!-- HEADER -->
    <div class="section-header">

      <span class="section-badge">Referenzen & Bewertungen</span>

      <h2>Unsere Arbeit spricht für sich</h2>

      <p>
        Einblicke in echte Projekte und ehrliche Rückmeldungen unserer Kunden.
      </p>

    </div>

    <!-- REFERENCES GRID -->
    <div class="references-grid">

      <div
          class="reference-card"
          v-for="ref in references"
          :key="ref.title"
      >

        <div class="reference-image">
          <img :src="ref.image" :alt="ref.title" loading="lazy" />
          <div class="overlay">
            <ExternalLink/>
          </div>
        </div>

        <div class="reference-content">

          <div class="reference-icon">
            <component :is="ref.icon"/>
          </div>

          <span class="reference-category">
            {{ ref.category }}
          </span>

          <h3>{{ ref.title }}</h3>

          <p>{{ ref.text }}</p>

        </div>

      </div>

    </div>

    <!-- REVIEWS -->
    <div class="reviews-grid">

      <div
          class="review-card"
          v-for="review in reviews"
          :key="review.name"
      >

        <div class="quote-icon">
          <Quote/>
        </div>

        <div class="stars">
          <Star v-for="n in 5" :key="n"/>
        </div>

        <p class="review-text">
          "{{ review.text }}"
        </p>

        <div class="review-author">
          {{ review.name }}
        </div>

      </div>

    </div>

  </section>

</template>

<style scoped>
</style>
